import { render, staticRenderFns } from "./D009.vue?vue&type=template&id=197c3c87&scoped=true&"
import script from "./D009.vue?vue&type=script&lang=js&"
export * from "./D009.vue?vue&type=script&lang=js&"
import style0 from "./D009.vue?vue&type=style&index=0&id=197c3c87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c3c87",
  null
  
)

export default component.exports